import ShareImg from '@assets/images/video-tutorial/share.png'
import { VideoTutorial } from '@components/VideoTutorial'
import { useVideoTutorial } from '@components/VideoTutorial/useVideoTutorial'
import type React from 'react'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { VideoTutorialWrap } from '../VideoTutorialWrap'

interface Props {
  hide: boolean
}

export const ShareTutorial: React.FC<Props> = ({ hide }) => {
  const { shareId, handleViewedTutorial } = useVideoTutorial()

  if (!shareId) {
    return null
  }

  const handleLinkClick = () => {
    handleViewedTutorial(shareId)
    sendGtmEvent(GtmTriggerName.SHARE_INTRO)
  }

  const handleCloseClick = () => {
    handleViewedTutorial(shareId)
  }

  return (
    <VideoTutorialWrap hide={hide}>
      <VideoTutorial
        title="Welcome to Share"
        description="Check out the best ways to share the sitemap"
        img={ShareImg}
        link="https://youtu.be/SoIe1yXoo8c?si=r5QQSf9zzDhIcoqn"
        position="left-top"
        onLinkClick={handleLinkClick}
        onCloseClick={handleCloseClick}
      />
    </VideoTutorialWrap>
  )
}
